import { Component, Input, OnInit } from '@angular/core';
import { PartnerDataModel } from 'src/app/account/models/accountModel';
import { AccountService } from 'src/app/account/services/account.service';
import * as moment from 'moment';
import { DateFormat } from 'src/app/constants';

@Component({
  selector: 'app-store-menu-list',
  templateUrl: './store-menu-list.component.html',
  styleUrls: ['./store-menu-list.component.scss']
})
export class StoreMenuListComponent implements OnInit {

  @Input() user: PartnerDataModel;

  @Input() isCustomerUser: boolean;

  short_name: string;

  lastLoginDate: string;

  constructor(private accountService: AccountService) { 
   
  }

  ngOnInit(): void { 
    this.short_name = this.user ? this.user.short_name : '';
    this.lastLoginDate = (this.user && this.user.last_login_utc) ? moment.utc(this.user.last_login_utc).local().format(DateFormat.formatB) : 'Never';
  }

  navigationClick(id: string) {
    const menuBarAnchorElems = document.querySelectorAll('#desktopMenu ul li a');
    const mobMenuBarAnchorElems = document.querySelectorAll('#mobileMenuList ul li a');
    // if (menuBarAnchorElems && menuBarAnchorElems.length) {
    //   menuBarAnchorElems.forEach(elem => {
    //     elem.classList.remove('active');
    //   });
    //     const selector = 'a#' + id;
    //   const elem = Array.from(menuBarAnchorElems).find((elem: any) =>  elem.matches(selector));
    //   if (elem) {
    //     elem.classList.add('active');
    //   }
    // }
    

    //  if (mobMenuBarAnchorElems && mobMenuBarAnchorElems.length) {
    //   mobMenuBarAnchorElems.forEach(elem => {
    //     elem.classList.remove('mob-menu-active');
    //   });
    //   const selector = 'a#' + id;
    //   const elem = Array.from(mobMenuBarAnchorElems).find((elem: any) =>  elem.matches(selector));
    //   // console.log('elem', elem);
    //   if (elem) {
    //     elem.classList.add('mob-menu-active');
    //   }
    // }


    if (id === 'home-menu') {
      this.accountService.goHome();
    } else if (id === 'partreg-menu') {
      this.accountService.navigateNormal('dashboard/createpartner');
    } else if (id === 'auditlogs-menu') {
      this.accountService.navigateAfterLogin('admin/auditLogs');
    } else if (id === 'approvals-menu') {
      this.accountService.navigateAfterLogin('admin/approvals');
    }

  }

}
